// src/components/PawAlertAIPolicy.js
import React from 'react';
import Policy from './Policy';
import PawAlertAIIcon from './assets/pawalert-ai-icon.png';
import { Helmet } from 'react-helmet';

function PawAlertAIPolicy() {
  return (
    <div>
      <Helmet>
        <title>PawAlert AI Integrity Policy</title>
        <meta name="description" content="Privacy and security policy for PawAlert AI application." />
      </Helmet>
      <Policy title="PawAlert AI Integrity Policy" icon={PawAlertAIIcon}>
        The purpose of this policy is to outline the commitment of PawAlert AI to the privacy and security of user data. This policy covers the collection, storage, use, and deletion of user data by the application.<br /><br />

        <strong>Collection of User Data:</strong> PawAlert AI does not collect, store, or share any personal data from its users. All data processed by the application, including pet detection information, is handled locally on the user's device. No data is transmitted or shared with any third parties.<br /><br />

        <strong>Storage of User Data:</strong> All data related to pet detection is stored exclusively on the user's device. The application does not utilize cloud storage or external servers. Users can configure specific areas on their screen or camera where pet detection is disabled, ensuring personalized privacy controls.<br /><br />

        <strong>Use of Data:</strong> PawAlert AI does not use any personal data for advertising, marketing, or any other purposes beyond the functionality of the application. The app is intended for personal use only.<br /><br />

        <strong>User Control over Data:</strong> Users have complete control over all data processed by PawAlert AI. They can delete any data at any time directly from their device. The application does not retain any copies of deleted data.<br /><br />

        <strong>Data Security:</strong> PawAlert AI implements robust security measures to protect user data from unauthorized access or manipulation. All processing occurs locally, minimizing security risks.<br /><br />

        <strong>Compliance with Laws and Regulations:</strong> PawAlert AI adheres to all relevant privacy and data protection laws and regulations, including GDPR and CCPA.<br /><br />

        <strong>Changes to this Policy:</strong> PawAlert AI may update this policy periodically to reflect changes in technology, legal requirements, or other factors. Updated policies will be available on the application's website and the Google Play Store.<br /><br />

        By using PawAlert AI, users acknowledge and agree to this policy and the practices described in it.
      </Policy>
    </div>
  );
}

export default PawAlertAIPolicy;
